import type { SVGProps } from "react";
export const Warning = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M1.86572 20.5L12.0002 3L22.1347 20.5H1.86572ZM4.45022 19H19.5502L12.0002 6L4.45022 19ZM12.5732 17.573C12.7297 17.4167 12.808 17.2257 12.808 17C12.808 16.7743 12.7297 16.5833 12.5732 16.427C12.4169 16.2705 12.2259 16.1923 12.0002 16.1923C11.7746 16.1923 11.5836 16.2705 11.4272 16.427C11.2707 16.5833 11.1925 16.7743 11.1925 17C11.1925 17.2257 11.2707 17.4167 11.4272 17.573C11.5836 17.7295 11.7746 17.8077 12.0002 17.8077C12.2259 17.8077 12.4169 17.7295 12.5732 17.573ZM11.2502 15.1923H12.7502V10.1923H11.2502V15.1923Z"
			fill="currentColor"
		/>
	</svg>
);
